export const studentAssessmentEntryPath = (access) => {
  if (access?.type === "assignment" && typeof access.assignmentId === "string" && access.assignmentId) {
    return `/enter-quiz?assignmentId=${encodeURIComponent(access.assignmentId)}`;
  }
  if (
    access?.type === "quiz-code" &&
    typeof access.teacherUid === "string" && access.teacherUid &&
    typeof access.quizCode === "string" && access.quizCode
  ) {
    return `/enter-quiz?teacherUid=${encodeURIComponent(access.teacherUid)}&quizCode=${encodeURIComponent(access.quizCode)}`;
  }
  throw new Error("The assessment access context is invalid.");
};
